export function getImageFraction(options) {
    const {
        breakpoints: breakpointOptions = [],
        multiple = 60,
        ratio = null,
        maxPixelRatio = 2,
        path = null,
    } = options;
    let {
        fraction = 1,
    } = options;

    let maxWidth = 0;
    const sizes = [];
    const formats = {};
    const breakpoints = [
        { key: 'xs', breakpoint: 0, container: 355 },
        { key: 'xs', breakpoint: 415, container: 540 },
        { key: 'sm', breakpoint: 600, container: 520 },
        { key: 'md', breakpoint: 768, container: 660 },
        { key: 'lg', breakpoint: 992, container: 900 },
        { key: 'xl', breakpoint: 1280, container: 1160 },
        { key: 'xxl', breakpoint: 1440, container: 1320 },
        { key: 'xxxl', breakpoint: 1660, container: 1540 },
    ];

    breakpoints.forEach((breakpoint) => {
        fraction = breakpointOptions?.[breakpoint.key]?.fraction || fraction;

        const size = {
            breakpoint: breakpoint.breakpoint,
            width: breakpoint.container * fraction,
        };
        sizes.push(`${(size.breakpoint > 0 ? `(min-width: ${size.breakpoint}px) ` : '')}${size.width}px`)

        const width = Math.ceil((breakpoint.container * fraction) / multiple) * multiple;
        const height = ratio ? Math.round(width / ratio) : null;
        maxWidth = Math.max(maxWidth, width);

        for (let pixelRatio = 1; pixelRatio <= maxPixelRatio; ++pixelRatio) {
            let formatWidth = width * pixelRatio;
            let formatHeight = height ? height * pixelRatio : null;

            formats[`${formatWidth}x${formatHeight}`] = {
                'width': formatWidth,
                'height': formatHeight
            };
        }
    });

    const maxHeight = ratio ? Math.round(maxWidth / ratio) : null;
    const src = getCloudImageUrl(path, {
        'width': maxWidth,
        'height': maxHeight,
    });
    const srcset = {};

    Object.values(formats).forEach((format) => {
        srcset[`${format.width}w`] = getCloudImageUrl(path, {
            'width': format.width,
            'height': format.height,
        });
    })

    return {
        'src': src,
        'srcSet': Object.entries(srcset).map(([key, value]) => `${value} ${key}`).join(', '),
        'width': maxWidth,
        'height': maxHeight,
        'sizes': sizes.reverse().join(', '),
    };
}

export function getCloudImageUrl(url, params = {}) {
    const cloudimageToken = process.env.NODE_ENV === 'production' ? 'aicuplpjbq' : null;

    if (!cloudimageToken || !url) return url;

    // Strip timestamp parameter from (Shopware) URL if present
    const cleanUrl = url.replace(/\?ts=\d+$/, '');

    let cloudimageUrl = new URL(`https://${cloudimageToken}.cloudimg.io/v7/${cleanUrl}`);

    Object.entries(params).forEach(([key, value]) => {
        cloudimageUrl.searchParams.append(key, value === true ? 1 : value);
    });

    return cloudimageUrl.toString();
}
